import _ from 'lodash';
import moment from 'moment';
import filter from '@/store/modules/filter';

class Util {
	date(iso) {
		return moment(iso).format('YYYY-MM-DD');
	}

	dateFormat(iso, pattern = 'YYYY-MM-DD HH:mm') {
		return moment(iso).format(pattern);
	}

	numberFormat(num = 0) {
		return num.toLocaleString();
	}

	format(v, { default_value = '-', pattern = 'YYYY-MM-DD HH:mm' } = {}) {
		if (_.isNil(v)) return default_value;

		if (_.isNumber(v)) {
			return this.numberFormat(v);
		} else if (_.isString(v)) {
			return this.dateFormat(v, pattern);
		}
	}

	getRegisterGradeLabel(grade, default_value = undefined) {
		const _grade = _.find(filter.state.gradeList, { id: grade });
		return _.get(_grade, 'name', default_value);
	}

	getRegisterGrade(grade, target = 'name', default_value = undefined) {
		const _grade = _.find(filter.state.gradeList, { id: grade });
		return _.get(_grade, target, default_value);
	}

	getGenderLabel(code, default_value = undefined) {
		const gender = _.find(filter.state.genderList, { id: code });
		return _.get(gender, 'name', default_value);
	}

	getSkinTypeLabel(code, default_value = undefined) {
		const item = _.find(filter.state.skinTypeList, { id: code });
		return _.get(item, 'name', default_value);
	}

	getBlindLabel(code, default_value = undefined) {
		const item = _.find(filter.state.blindList, { id: code });
		return _.get(item, 'name', default_value);
	}

	getPagination({ page = 1, total = 0, limit = 50 } = {}) {
		return {
			page,
			total,
			limit,
			page_count: Math.ceil(total / limit),
			offset: (page - 1) * limit,
		};
	}

	error(e) {
		console.error(e);
		alert(e.message || e);
	}
}

export default new Util();
